import React from 'react';
import Card from './Card';

/**
 * Semitones spanned by the hover ticks, from the first card to the last. Widen
 * it for a more dramatic sweep — `tick` carries the transpose on its tone layer
 * only, so its fixed noise grain masks a narrow range.
 */
const HOVER_PITCH_SPAN = 12;

/** Evenly spaced, centred on the deck: lowest on the left, highest on the right. */
const hoverPitchFor = (index: number, total: number): number =>
  total < 2 ? 0 : (HOVER_PITCH_SPAN * index) / (total - 1) - HOVER_PITCH_SPAN / 2;

interface CardPickerProps {
  options: (string | number)[];
  onSelectCard: (value: string | number) => void;
  selectedCard?: string | number;
  hasLockedIn?: boolean;
  isRevealed?: boolean;
}

const CardPicker: React.FC<CardPickerProps> = ({
  options,
  onSelectCard,
  selectedCard,
  hasLockedIn = false,
  isRevealed = false,
}) => {
  const normalizedSelected = selectedCard !== undefined ? String(selectedCard) : undefined;
  return (
    <div className="card-picker" aria-live="polite">
      <h3 className="card-picker__title">Pick your T-shirt size</h3>
      <div className="card-picker__options">
        {options.map((option, index) => {
          const valueKey = String(option);
          return (
            <Card
              key={valueKey}
              value={option}
              showValue
              onClick={() => onSelectCard(option)}
              isSelected={normalizedSelected === valueKey}
              disabled={isRevealed}
              className="card--option"
              clickCue="tap"
              hoverCue="tick"
              hoverPitch={hoverPitchFor(index, options.length)}
            />
          );
        })}
      </div>
      <p className="card-picker__hint">
        {isRevealed
          ? 'Votes revealed! Start a new round to vote again.'
          : hasLockedIn
            ? 'You can change your vote until all votes are revealed.'
            : 'Tap a card to lock in your vote.'}
      </p>
    </div>
  );
};

export default CardPicker;
